import {
  PASSWORD_VALIDATION_MESSAGE,
  PASSWORD_CONFIRM_VALIDATION_MESSAGE,
  TEL_VALIDATION_MESSAGE
} from '../constants';

const CLASSNAME = 'update-user-account-form';

const passwordRegex = '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\\s).{8,}$';
const telRegex = '^\\+[0-9\\-\\s]+';

const FORM_SCHEMA = {
  type: 'object',
  properties: {
    tel: {
      fieldId: 'tel',
      label: 'Telephone',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '+447...',
      type: 'string',
      pattern: telRegex,
      errorMessage: TEL_VALIDATION_MESSAGE,
      isRequired: false
    },
    password: {
      fieldId: 'password',
      label: 'New Password',
      showInForm: true,
      formFieldType: 'password',
      placeholder: '',
      type: 'string',
      pattern: passwordRegex,
      errorMessage: PASSWORD_VALIDATION_MESSAGE,
      isRequired: false
    },
    passwordConfirm: {
      fieldId: 'passwordConfirm',
      label: 'Confirm New Password',
      showInForm: true,
      formFieldType: 'password',
      placeholder: '',
      type: 'string',
      const: { $data: '1/password' },
      errorMessage: PASSWORD_CONFIRM_VALIDATION_MESSAGE,
      isRequired: false
    }
  },
  required: []
};

export { CLASSNAME, FORM_SCHEMA };
